export default "__VITE_ASSET__CKa42flc__"